import React, { forwardRef, memo } from 'react';
import flow from 'lodash/flow';
import cn from 'classnames';
import styles from './darkoverlay.module.scss';

/* Types */
import { Children } from 'types/base.types';

/* Utils */
import { noop } from '@utils/event';

type DarkOverlayProps = {
  show: boolean;
  fixed: boolean;
  absolute: boolean;
  onClick: BaseAnyFunction;
  children: Children;
  className: string;
};

type RefProp = ((instance: HTMLDivElement | null) => void) | React.RefObject<HTMLDivElement | null> | null | undefined;

const DarkOverlay = ({ show = false, fixed = false, absolute = false, onClick = noop, children, className = '' }: DarkOverlayProps, ref: RefProp) => {
  const overlayStyles = cn(
    styles.overlay,
    {
      [styles.show]: show,
      [styles.fixed]: fixed,
      [styles.absolute]: absolute,
    },
    className,
  );

  return (
    <div ref={ref} onClick={onClick} className={overlayStyles}>
      {children}
    </div>
  );
};

export default flow(forwardRef, memo)(DarkOverlay);
